/**
 * 🟦 V12.10 — Sistema de Comandos Internos del Genio.
 *
 * Capa unificada de comandos que el Genio (Lyon) puede emitir hacia
 * el resto de la app (Builder, Dashboard, etc.). Los listeners se
 * registran via `window.addEventListener('message', ...)` dentro de
 * cada feature que quiera responder a un comando. La emisión es
 * fire-and-forget y NO bloquea el render del Genio.
 *
 * Comandos soportados:
 *  - 'open-marketplace'   → abre el Marketplace de Recetas
 *  - 'open-stylepacks'    → abre Style Packs
 *  - 'open-recipes'       → abre el panel de Recetas locales
 *  - 'open-onboarding'    → abre el Wizard de Onboarding
 *  - 'open-import'        → abre el importer JSON
 *  - 'infer-style'        → abre Vision / Style Inference
 */

export function runGenioCommand(cmd, payload) {
  try {
    window.postMessage(
      { type: 'genio-command', cmd, payload: payload || null },
      window.location.origin,
    );
  } catch {
    /* fail silently */
  }
}

export default runGenioCommand;
